const state = {
  loading: false,
  success: false,
  error: false,
  productList: [],
  products: {},
};

export default state;
